import { connect } from "react-redux";
import { getListThuDelete } from "actions/DanhSachThuDelete";
import { DanhSachThuBiXoa } from "components/ThongKe/DanhSachThuBiXoa";

const mapStateToProps = (state) => ({
  DanhSachThuBiXoa: state.DanhSachThuBiXoa,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListThuDelete: (dataSearch) => dispatch(getListThuDelete(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DanhSachThuBiXoa);
